import React from 'react';
import cx from 'classnames';

import iconAccessibility from '../utils/iconAccessibility';
import styles from './Icons.module.scss';

export interface Props {
  accessibilityLabel?: string;
  className?: Parameters<typeof cx>[0];
}

export const Configure: React.FC<Props> = ({
  accessibilityLabel,
  className,
}) => (
  <i className={cx(styles.icon, className)}>
    <svg
      width={24}
      height={24}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...iconAccessibility(accessibilityLabel)}
    >
      <path
        d='M21 8h-4M12 8H3M16.5 6h-4a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h4a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5zM7 16H3M21 16h-9M7.5 18h4a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-4a.5.5 0 00-.5.5v3a.5.5 0 00.5.5z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinejoin='round'
      />
    </svg>
  </i>
);

Configure.displayName = 'Configure';
export default Configure;
